import { render, staticRenderFns } from "./index.vue?vue&type=template&id=383c68c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=383c68c4&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=383c68c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b66c2628a85b517bb8b270c746a8724b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c68c4",
  null
  
)

export default component.exports